import React from 'react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'

import {
  EuiSpacer,
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem
} from '@elastic/eui'

export default function LatestArticle() {

  return (
    <React.Fragment>
      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/720p_Serie_CGI_Befehle/Software_Menu/Sichern_Wiederherstellen/">
                  <StaticImage
                    src='../../../images/720p_Series_CGI_List/Software_Menu/WebUI-Software_Backup_square.png'
                    alt="720p Serie CGI List - Software Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                    />
                </Link>
              }
              title="Backup / Restore"
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/720p_Serie_CGI_Befehle/Software_Menu/Sprache/">
                  <StaticImage
                    src='../../../images/720p_Series_CGI_List/Software_Menu/WebUI-Software_Language_square.png'
                    alt="720p Serie CGI List - Software Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                    />
                </Link>
              }
              title="Language"
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/720p_Serie_CGI_Befehle/Software_Menu/Neustart_Reset/">
                  <StaticImage
                    src='../../../images/720p_Series_CGI_List/Software_Menu/WebUI-Software_Reboot&Reset_square.png'
                    alt="720p Serie CGI List - Software Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                    />
                </Link>
              }
              title="Reboot / Reset"
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/720p_Serie_CGI_Befehle/Software_Menu/Update/">
                  <StaticImage
                    src='../../../images/720p_Series_CGI_List/Software_Menu/WebUI-Software_Reboot&Reset_square.png'
                    alt="720p Serie CGI List - Software Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                    />
                </Link>
              }
              title="Update"
            />
          </EuiFlexItem>
          <EuiFlexItem>
          </EuiFlexItem>
          <EuiFlexItem>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </React.Fragment>
  );
}
